interface SortableEnrollment {
    course: any;
    status: string;
    enrolledAt: string;
}

const courseIdOf = (course: any): number => {
    if (typeof course === 'number') return course;
    if (course && typeof course === 'object' && course.id) return Number(course.id);
    if (typeof course === 'string') {
        const match = course.match(/(\d+)$/);
        return match ? parseInt(match[1]) : 0;
    }
    return 0;
};

const STATUS_RANK: Record<string, number> = {
    in_progress: 1,
    enrolled: 2,
    failed: 3,
    completed: 4,
};

/** Sortierung laut #354: Pflichtkurse → in Bearbeitung → nicht begonnen → abgeschlossen. */
export function sortMyCourses<T extends SortableEnrollment>(
    enrollments: T[],
    assignmentData: Record<number, unknown>
): T[] {
    const rank = (e: T): number => {
        if (e.status !== 'completed' && assignmentData[courseIdOf(e.course)]) return 0;
        return STATUS_RANK[e.status] ?? 2;
    };
    return [...enrollments].sort(
        (a, b) => rank(a) - rank(b) || b.enrolledAt.localeCompare(a.enrolledAt)
    );
}
